import ApiValidationErrorModel from '@/models/errors/ApiValidationErrorModel';

export default class ApiValidationError extends Error {
    public validationErrors: ApiValidationErrorModel[] = [];

    public getErrorDescriptions() {
        const values: string[] = [];

        if ( this.validationErrors.length > 0) {
            const len = this.validationErrors.length - 1;

            for (let i = 0; i <= len; i++)
            {
                values.push(this.validationErrors[i].errorDescription);
            }
        }

        return values;
    }
}
